import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const Dropdown = ({ trigger, options = [], className = '', dropdownClassName = '', position = 'bottom-right' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const [menuStyles, setMenuStyles] = useState({});
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setMenuStyles({
        position: "absolute",
        top: rect.bottom + window.scrollY + 4, // slight gap
        left: position.includes("right")
          ? rect.right + window.scrollX - 150 // adjust width as needed
          : rect.left + window.scrollX,
        zIndex: 9999,
      });
    }
  }, [isOpen, position]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !triggerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const handleOptionClick = (option) => {
    if (option.onClick) option.onClick();
    if (!option.keepOpen) setIsOpen(false);
  };

  const menu = (
    <div
      ref={dropdownRef}
      style={menuStyles}
      className={`w-fit min-w-[140px] rounded-lg bg-white shadow-lg border border-gray-200 py-1 flex flex-col ${dropdownClassName}`}
    >
      {options.map((option, i) => (
        <button
          key={i}
          onClick={() => handleOptionClick(option)}
          className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        >
          {option.label}
        </button>
      ))}
    </div>
  );

  return (
    <div ref={triggerRef} className={`inline-block ${className}`}>
      <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
        {trigger}
      </div>
      {isOpen && createPortal(menu, document.body)}
    </div>
  );
};

export default Dropdown;
